import { FormValidations } from '@/utils';
import { EmailValidationContext } from '@/constants/EmailValidationContext';

/**
 * Schema de validação para ContactForm.
 * 
 * Validações de Email:
 * 1. IsRequired + IsEmailValid (formato)
 * 2. NoDuplicatesNormalized (cross-form: não pode repetir entre renters da proposta)
 * 3. IsEmailAvailable (DB: email único globalmente, excluindo o próprio renter se editando)
 * 
 * Validações de Phone:
 * 1. IsRequired + IsPhoneValid (formato)
 * 2. NoDuplicatesNormalized (cross-form: não pode repetir entre renters da proposta)
 * 3. IsPhoneAvailable (DB: telefone único, skip se não mudou do original, ignorando o próprio renter)
 */
export type PhoneConflictInfo = {
	phone: string;
	ownerId?: string;
	ownerName?: string;
	ownerDocumentMasked?: string;
	ownerPhone?: string;
};

export function ContactFormSchema(
	renterId: string,
	phoneType: 'Cel' | 'Tel' = 'Cel',
	originalEmail?: string,
	originalPhone?: string,
	forbiddenEmails: string[] = [],
	forbiddenPhones: string[] = [],
	onPhoneConflict?: (info: PhoneConflictInfo) => void,
) {
	const emailValidations = [
		FormValidations.IsRequired,
		FormValidations.IsEmailValid,
		FormValidations.NoDuplicatesNormalized(
			forbiddenEmails,
			'Este e-mail já está sendo usado por outro locatário nesta proposta.',
			'caseInsensitive',
		),
		FormValidations.IsEmailAvailable(
			EmailValidationContext.Renter,
			originalEmail,
			renterId || undefined,
		),
	];

	const phoneValidations = [
		FormValidations.IsRequired,
		FormValidations.IsPhoneValid(phoneType),
		FormValidations.NoDuplicatesNormalized(
			forbiddenPhones,
			'Este telefone já está sendo usado por outro locatário nesta proposta.',
			'numericOnly',
		),
		FormValidations.IsPhoneAvailable(originalPhone, onPhoneConflict, renterId || undefined),
	];

	return Object.freeze({
		email: emailValidations,
		phone: phoneValidations,
	});
}
